import classNames from "classnames";
import React, { ReactNode } from "react";
import InfoTooltip from "Shared/InfoTooltip";
import styled from "styled-components";

const Wrapper = styled.span.attrs(() => ({
    className: "PaymentDisclaimer__container",
}))`
    color: ${(props) => props.theme.palette.grey[70]};
    margin-left: 0.5em;
`;

export interface PaymentDisclaimerProps {
    additionalDisclaimer?: ReactNode;
    className?: string;
    defaultDisclaimer: string;
}

const PaymentDisclaimer: React.FunctionComponent<PaymentDisclaimerProps> = ({
    className,
    additionalDisclaimer,
    defaultDisclaimer,
}) => {
    const text = additionalDisclaimer ? (
        <span>
            {additionalDisclaimer}
            <br />
            {defaultDisclaimer}
        </span>
    ) : (
        defaultDisclaimer
    );

    return (
        <Wrapper>
            <InfoTooltip className={classNames("PaymentDisclaimer__tooltip", className)} text={text} />
        </Wrapper>
    );
};

export default PaymentDisclaimer;
